import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface ModalContextType {
  isAnyModalOpen: boolean;
  registerModal: (id: string) => void;
  unregisterModal: (id: string) => void;
}

const ModalContext = createContext<ModalContextType>({
  isAnyModalOpen: false,
  registerModal: () => {},
  unregisterModal: () => {},
});

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [openModals, setOpenModals] = useState<Set<string>>(new Set());

  const registerModal = useCallback((id: string) => {
    setOpenModals(prev => new Set(prev).add(id));
  }, []);

  const unregisterModal = useCallback((id: string) => {
    setOpenModals(prev => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  }, []);

  const value = {
    isAnyModalOpen: openModals.size > 0,
    registerModal,
    unregisterModal,
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModalContext = () => useContext(ModalContext);
